// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"16":"7112840a","230":"component---src-pages-index-jsx","351":"commons","909":"component---src-pages-play-jsx"}[chunkId] + "-" + {"16":"78f439a90988a15ff477","230":"6a1111324032328ce5d7","351":"bb4be47db68ae1d9b1f8","909":"855d0735f3dcbf922cd5"}[chunkId] + ".js";
};